var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as PassengersDetailsState from './passengers-details.state';
import * as PassengersDetailsActions from './passengers-details.actions';
import * as _ from 'lodash';
var initialState = PassengersDetailsState.initialState;
/** mappers */
var mapFrequentFlyerOptions = function (programs) {
    return programs['data'].map(function (program) { return ({ text: program.name, value: program.code }); });
};
var ɵ0 = mapFrequentFlyerOptions;
var mapEmergencyData = function (emergencyData) { return emergencyData && emergencyData.declined ? __assign({}, emergencyData, { emName: null, emCountry: null, emPrefix: null, emPhone: null }) : emergencyData; };
var ɵ1 = mapEmergencyData;
var mapListTravelDoc = function (docs, newDocument, mainInfo) {
    // get gender and birthdate from main info form if both are NULL from travel doc object
    var newDocumentCopy;
    newDocumentCopy = newDocument ? _.cloneDeep(newDocument) : {};
    newDocumentCopy.birthDate = (!newDocumentCopy.birthDate && mainInfo) ? mainInfo.birthDate : newDocumentCopy.birthDate;
    newDocumentCopy.gender = (!newDocumentCopy.gender && mainInfo) ? mainInfo.gender : newDocumentCopy.gender;
    if (docs.length === 0) {
        return [newDocumentCopy];
    }
    return docs.map(function (it) { return (__assign({}, it, newDocumentCopy)); });
};
var ɵ2 = mapListTravelDoc;
var updatePassengers = function (passengers, passenger) {
    return passengers.map(function (pax) { return pax.idPax === passenger.idPax ? passenger : pax; });
};
var ɵ3 = updatePassengers;
export var getLoading = function (state) { return state.loading; };
export var getBookedTrip = function (state) { return state.bookedTrip; };
export var getInfoPax = function (state) { return state.data.infoPax; };
export var getDocumentTypes = function (state) { return state && state.documentTypes; };
export var getFrequentFlyerPrograms = function (state) { return state.frequentFlyerPrograms; };
export var isFormChanges = function (state) { return state.formChanges; };
export var getNotif = function (state) { return state.notif; };
export var getFare = function (state) { return state && state.data && state.data.fare; };
export var getPassengers = function (state) { return state.data.infoPax.listPax; };
export var getPassengerAtIndex = function (state, routerState) {
    return !_.isEmpty(state) && !_.isNil(routerState.queryParams['id']) && state.find(function (s) { return Object.is(+routerState.queryParams['id'], s.idPax); });
};
export var getEmergencyData = function (state) { return state.emergencyData; };
export var getLocations = function (state) { return state.translate.locations; };
export function reducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case PassengersDetailsActions.ActionTypes.LOADING:
            return __assign({}, state, { loading: true, bookedTrip: null });
        case PassengersDetailsActions.ActionTypes.PUT_BOOKEDTRIP_PASSENGERS_DETAILS: {
            return __assign({}, state, { loading: false, bookedTrip: action.payload });
        }
        case PassengersDetailsActions.ActionTypes.LOAD_DOCUMENT_TYPES_SUCCESS: {
            return __assign({}, state, { documentTypes: action.payload });
        }
        case PassengersDetailsActions.ActionTypes.LOAD_FREQUENT_FLYER_PROGRAMS_SUCCESS: {
            var programs = mapFrequentFlyerOptions(action.payload);
            return __assign({}, state, { frequentFlyerPrograms: programs });
        }
        case PassengersDetailsActions.ActionTypes.UPDATE_FORM_CHANGED: {
            return __assign({}, state, { formChanges: __assign({}, state.formChanges, action.payload) });
        }
        case PassengersDetailsActions.ActionTypes.HIDE_NOTIFICATION: {
            return __assign({}, state, { notif: __assign({}, state.notif, { show: false }) });
        }
        case PassengersDetailsActions.ActionTypes.SAVE_PASSENGER_SUCCESS: {
            var passenger_id_1 = action.payload.rq.passenger_id;
            var _a = action.payload.rq.data, emergencyContact = _a.emergencyContact, travelDocument = _a.travelDocument, frequentFlyer = _a.frequentFlyer, contact = _a.contact, mainInfo = _a.mainInfo, studentInfo = _a.studentInfo, residentInfo = _a.residentInfo, travelInsurance = _a.travelInsurance, workInfo = _a.workInfo;
            var passengers = getPassengers(state.bookedTrip);
            var passenger = passengers.find(function (ps) { return Object.is(ps.idPax, passenger_id_1); });
            var newPassenger = __assign({}, passenger, frequentFlyer, contact, mainInfo, residentInfo, { studentDocNumber: studentInfo.studentDocNumber, studentfiscalNumber: studentInfo.studentfiscalNumber, workTrip: workInfo && workInfo.workTrip === 'yes' ? true : false, travelInsurance: travelInsurance, emergencyData: mapEmergencyData(emergencyContact), listTravelDoc: mapListTravelDoc(passenger.listTravelDoc, travelDocument, mainInfo), tierLevelFF: action.payload.res['passenger-tier-level-info'] ? action.payload.res['passenger-tier-level-info'][passenger_id_1] : undefined });
            var listPax = updatePassengers(passengers, newPassenger);
            var bookedTrip = _.cloneDeep(state.bookedTrip);
            bookedTrip.data.infoPax.listPax = listPax;
            return __assign({}, state, { 
                // listPax: updatePassengers(passengers, newPassenger),
                bookedTrip: bookedTrip, formChanges: initialState.formChanges });
        }
        case PassengersDetailsActions.ActionTypes.SAVE_PASSENGER_ERRORS: {
            return __assign({}, state, { notif: {
                    icon: '',
                    title: 'TAP',
                    message: action.payload.map(function (error) { return error.desc; }),
                    style: 'alert',
                    show: true
                } });
        }
        case PassengersDetailsActions.ActionTypes.CANCEL_EDITING: {
            return __assign({}, state, { formChanges: initialState.formChanges, notif: initialState.notif });
        }
        default:
            return state;
    }
}
export { ɵ0, ɵ1, ɵ2, ɵ3 };
